/**
 * SEO Page Disclaimer
 * ===================
 * Legal disclaimer required on ALL generated SEO pages.
 * Covers data accuracy, sources, competitor mentions,
 * and compliance with Danish Markedsføringsloven / Forbrugerombudsmanden.
 */

import React from 'react';
import { AlertTriangle } from 'lucide-react';

const sans = { fontFamily: '"DM Sans", "Space Grotesk", sans-serif' };

export default function SEODisclaimer({ page }) {
  const lastRefresh = page?.last_data_refresh || page?.created_date;
  const formattedDate = lastRefresh
    ? new Date(lastRefresh).toLocaleDateString('da-DK', { day: 'numeric', month: 'long', year: 'numeric' })
    : null;

  return (
    <section className="py-8 bg-gray-100 border-t border-gray-200" style={sans}>
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-start gap-3 mb-3">
            <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
            <h4 className="font-semibold text-gray-700 text-sm">Ansvarsfraskrivelse og datakilder</h4>
          </div>
          <div className="text-xs text-gray-500 leading-relaxed space-y-2 pl-8">
            {formattedDate && (
              <p>
                <strong>Sidst opdateret:</strong> {formattedDate}.
              </p>
            )}
            <p>
              Oplysningerne på denne side er indsamlet og beregnet ud fra offentligt tilgængelige datakilder, 
              herunder <a href="https://stromligning.dk" target="_blank" rel="noopener noreferrer" className="underline hover:text-gray-700">Strømligning.dk</a> og 
              producentoplysninger. Priser, besparelser og beregninger er vejledende estimater baseret på de angivne 
              forudsætninger (forbrug, kørsel, hjemmeladning) og kan variere afhængigt af individuelle forhold, 
              forbrugsmønstre og markedsudsving.
            </p>
            <p>
              <strong>enkel energi a/s tager forbehold for fejl og udeladelser</strong> i data modtaget fra 
              samarbejdspartnere, tredjepartskilder og eksterne API'er. Vi opfordrer alle til at verificere 
              oplysningerne hos de pågældende udbydere inden beslutning om køb eller leverandørskifte.
            </p>
            <p>
              Sammenligning med andre elselskaber og produkter er baseret på offentligt tilgængelige prisdata 
              på tidspunktet for sidegenerering. Konkurrenters priser, produkter og vilkår kan have ændret sig 
              siden da. Vi refererer udelukkende til faktuelt tilgængelige oplysninger og garanterer ikke 
              fuldstændighed eller aktualitet af tredjepartsdata.
            </p>
            <p>
              Besparelsesberegninger (herunder Saving Mode, laderabat og sammenligninger) er estimater – 
              ikke garantier. Faktiske besparelser afhænger af individuelle forhold, herunder spotprisudsving, 
              opladningsmønstre og forbrugsprofil. Historiske data er ikke garanti for fremtidige resultater.
            </p>
            <p>
              Indholdet på denne side er udarbejdet i overensstemmelse med den danske{' '}
              <a href="https://www.retsinformation.dk/eli/lta/2017/426" target="_blank" rel="noopener noreferrer" className="underline hover:text-gray-700">markedsføringslov</a> og 
              retningslinjer fra <a href="https://www.forbrugerombudsmanden.dk" target="_blank" rel="noopener noreferrer" className="underline hover:text-gray-700">Forbrugerombudsmanden</a>.
              Alle påstande om besparelser og priser er baseret på dokumenterbare kilder og gennemsigtige beregningsforudsætninger.
            </p>
            <p className="text-gray-400">
              enkel energi a/s · CVR 44305518 · Bryghuspladsen 8, 1473 København K · hej@enkelenergi.dk · 70 60 80 07
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}